// Hook für online/offline-Status. navigator.onLine ist auf iOS unzuverlässig
// (zeigt z.B. 'online' an obwohl Captive-Portal oder DNS-Fail), aber als
// erster Check ist es gut genug — echte Offline-Erkennung macht der
// Fetch-Fehlerpfad in api.ts.

import { useEffect, useState } from 'react';

export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return online;
}
